import launchDarkly from '@bambeehr/vue-launch-darkly';
import FeatureFlags from '@/constants/FeatureFlags';
import { DASHBOARD, OPERATING_FEED } from '@/lib/globals/routes';

/**
 * Get the default landing page route based on feature flags and user role
 * @param userRole - The user's role (e.g., 'employee', 'user', 'admin')
 * @returns The landing page route object
 */
export function getLandingPageRoute(userRole?: string) {
  const isH3FlywheelEnabled = launchDarkly.getFlags()[FeatureFlags.H3_FLYWHEEL];

  if (!isH3FlywheelEnabled) {
    return DASHBOARD;
  }

  if (userRole === 'employee') {
    // Feature flag 'employee-manager-operating-feed' removed - was always FALSE in production
    // Employees always go to DASHBOARD
    return DASHBOARD;
  }

  return OPERATING_FEED;
}

/**
 * Get the default landing page path based on feature flags and user role
 * @param userRole - The user's role (e.g., 'employee', 'user', 'admin')
 * @returns The landing page path string
 */
export function getLandingPagePath(userRole?: string): string {
  return getLandingPageRoute(userRole).path;
}
